import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignmentRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAlignmentRight"><Path fillRule="evenodd" clipRule="evenodd" d="M3 4H21V5.5H3V4ZM3 4H21V5.5H3V4ZM3 4H21V5.5H3V4Z" fill="currentColor"/><Path d="M21 11.25V12.75H11V11.25H21Z" fill="currentColor"/><Path d="M21 18.5V20H3V18.5H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlignmentRight;
